import * as am5 from '@amcharts/amcharts5';
import { ENV_CONFIG } from '../config/envConfig';

// Global flag to ensure license is only set once
let licenseSet = false;

/**
 * Set AM Charts license if available and not already set
 */
export const setAmChartsLicense = () => {
  if (!licenseSet && ENV_CONFIG.amChartsLicense) {
    am5.addLicense(ENV_CONFIG.amChartsLicense);
    licenseSet = true;
  }
};

/**
 * Create AM Charts root with license automatically applied
 */
export const createAmChartsRoot = (element: HTMLElement | string) => {
  setAmChartsLicense();
  return am5.Root.new(element);
};
